<template>
    <div class="pageClass WatchVideo" id="WatchVideo">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <video controls class="VideoPalyer" 
            ref = "videoPlayer"
            id="videoPlayer"
            :poster="VideoItem.ImageUri" 
            preload="none" 
            @pause="VideoPause()" 
            @play="VideoPlay()"
            @ended="VideoEnded()"
            :key="DownloadUrl"
            controlsList="nodownload"
            oncontextmenu="return false;"
            
            >
            <source v-if="DownloadUrl" :src="DownloadUrl" type="video/mp4">
        </video> 
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'WatchVideo',
    props: ['VideoItem'],
    components:{
    },
    data () {
        return {
            loginInputData:{
                Token :'',
                CustomerCode:'',
                StudentId:''
            },
            showLoading:false,
            DownloadUrl:'',
            VideoPlayed:false,
            timer:0,
            NextVideoTimer:0,
            currentTime:0,
            Played:false,
        }
    },
    watch: { 
        VideoItem: function(newVal, oldVal) { // watch it
            if(this.VideoItem.VideoUri == '' || this.VideoItem.VideoUri == undefined){
                alert('此課程影片尚未上架，請先觀看其他課程影片，謝謝。');   
                this.DownloadUrl ='';
            }else{
                this.DownloadUrl = this.VideoItem.VideoUri;
            }
            // this.GetFileDownloadUrl();
            this.currentTime = this.VideoItem.LastendTime;
            document.querySelector('#videoPlayer').currentTime = this.currentTime;
            this.Played = false;
        },
    },
    mounted(){
        this.deviceType();
        this.currentTime = this.VideoItem.LastendTime
        // this.$root.$refs.WatchVideo.videoPlayer = this.$refs.videoPlayer;
    },
    methods:{
        VideoPause(){
            // console.log('VideoPause')
            if(document.querySelector('#videoPlayer') != undefined){
                this.currentTime = document.querySelector('#videoPlayer').currentTime;
                // clearTimeout(this.NextVideoTimer);
                this.AddStudentMaterialUnitVideo();
            }
            clearTimeout(this.timer);
        },
        VideoPlay(){
            // clearTimeout(this.NextVideoTimer);
            if(!this.Played){
                this.$root.$refs.VideoClassPage.ActivateMaterialUnitByMaterialUnitId();
                document.querySelector('#videoPlayer').currentTime = this.currentTime;
                this.Played = true;
            }
            // console.log('VideoPlay')
            this.SaveVideoProgess();
        },
        VideoEnded(){
            clearTimeout(this.timer);
            this.AddStudentMaterialUnitVideo();
            // this.NextVideoTimer = setTimeout(() => {
            //     this.$root.$refs.VideoClassPage.NextVideo();
            // },5000)
            
        },
        SaveVideoProgess(){
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.currentTime = document.querySelector('#videoPlayer').currentTime;
                this.AddStudentMaterialUnitVideo();
                this.SaveVideoProgess();
            }, 60000)
        },
        //獲取影片連結
        /*GetFileDownloadUrl(){
            this.showLoading = true;
            const api =`${process.env.VIDEOAPIPATH}/api/Material/GetFileDownloadUrl`;
            const headers = {"Authorization": 'Bearer '+this.loginInputData.Token};
            const inputdata = 
            {
                "ItemId": this.VideoItem.VideoUri,
            };

            axios.post(api, inputdata, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.DownloadUrl != undefined){
                        this.DownloadUrl = response.data.DownloadUrl;
                        this.currentTime = this.VideoItem.LastendTime;
                    }else{
                        alert('此課程影片尚未上架，請先觀看其他課程影片，謝謝。');                        
                        console.error("There was an error!", response.data.ErrorCode);
                        this.DownloadUrl ='';

                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });

        },*/
        //存入影片播放進度
        AddStudentMaterialUnitVideo(){
            // this.showLoading = true;
            const api = process.env.VIDEOAPIPATH + '/api/Material/AddStudentMaterialUnitVideo'+
                        '?MaterialUnitVideoId=' + this.VideoItem.MaterialUnitVideoId+
                        '&LastEndTime='+Math.round(document.querySelector('#videoPlayer').currentTime,0)+
                        '&StudentId='+this.loginInputData.StudentId;
            const headers = {"Authorization": 'Bearer '+this.loginInputData.Token};

            axios.get(api,{headers})
                .then((response) => {
                    // this.showLoading = false;
                    // console.log('success');
                    if(response.data.IsSuccess){
                        this.VideoItem.LastendTime =  Math.round(document.querySelector('#videoPlayer').currentTime,0);
                        this.$root.$refs.VideoClassPage.SetChangVideoItem(this.VideoItem,'LastendTime')
                    }
                })
                .catch(error => {
                    // this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });

        },
        
        deviceType(){
            const ua = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                document.querySelector("#WatchVideo").style.width="100%"
            }
            else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                document.querySelector("#WatchVideo").style.width="100%"
            }
        },
    }, 
    created(){
        this.$root.$refs.WatchVideo = this;
        this.loginInputData.Token = sessionStorage.getItem('Token');
        this.loginInputData.StudentId = sessionStorage.getItem('StudentId');
    }
}
</script>





// WEBPACK FOOTER //
// src/components/VideoPage/WatchVideo.vue